"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _utils = require("@insided/shared/uikit/Editor/Attachments/utils");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _spamService = require("@insided/shared/services/spamService");

var _topicService = require("@insided/shared/services/topicService");

var _attachmentService = require("@insided/deprecated-services/attachmentService");

var _PageUnloadContext = require("@insided/shared/services/PageUnloadContext");

var _redirect = require("@insided/shared/utils/redirect");

var _globals = require("@insided/shared/utils/globals");

var _common = require("@insided/shared/utils/common");

var _Skeleton = require("@insided/destination/uikit/Skeleton");

var _excluded = ["submitRequest"];

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function newPost(topicId, type, parentReplyId) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(content) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _topicService.replyToTopic)(type, topicId, content, parentReplyId !== null && parentReplyId !== void 0 ? parentReplyId : undefined);

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}

function editTopicContent(topicId, type) {
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(content) {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0, _topicService.editContent)(type, topicId, content);

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
}

function editReplyContent(topicId, replyId, type) {
  return /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(content) {
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return (0, _topicService.editReply)(type, replyId, content);

            case 2:
              return _context3.abrupt("return", _context3.sent);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
}

function determineRequest(_ref4) {
  var replyId = _ref4.replyId,
      topicId = _ref4.topicId,
      type = _ref4.type,
      isTopicEdit = _ref4.isTopicEdit,
      parentReplyId = _ref4.parentReplyId;

  // Topic content edit
  if (isTopicEdit) {
    return editTopicContent(topicId, type);
  } // Reply edit


  if (replyId !== null) {
    return editReplyContent(topicId, replyId, type);
  } // New reply


  return newPost(topicId, type, parentReplyId);
}

function checkIsSpam(_x4, _x5, _x6) {
  return _checkIsSpam.apply(this, arguments);
}

function _checkIsSpam() {
  _checkIsSpam = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(replyId, type, isReply) {
    var _response2;

    return _regenerator.default.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;
            _context8.next = 3;
            return (0, _spamService.isSpam)(replyId, type, isReply);

          case 3:
            _response2 = _context8.sent;
            return _context8.abrupt("return", _response2.data.result.isSpam);

          case 7:
            _context8.prev = 7;
            _context8.t0 = _context8["catch"](0);
            _context8.next = 11;
            return new Promise(function (resolve) {
              resolve(false);
            });

          case 11:
            return _context8.abrupt("return", _context8.sent);

          case 12:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[0, 7]]);
  }));
  return _checkIsSpam.apply(this, arguments);
}

function getReplyIdFromResponse(response) {
  var _response$headers$loc;

  var location = (_response$headers$loc = response.headers.location) !== null && _response$headers$loc !== void 0 ? _response$headers$loc : '';
  var match = /replies\/(\d+)/.exec(location);
  return match ? Number(match[1]) : null;
}

var PostEditor = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(PostEditor, _Component);

  var _super = _createSuper(PostEditor);

  function PostEditor() {
    var _this$props$data, _this$props, _this$props$attachmen, _this$props2;

    var _this;

    (0, _classCallCheck2.default)(this, PostEditor);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "intersectionRef", (0, _preact.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "observer", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      // eslint-disable-next-line react/no-unused-state
      content: (_this$props$data = (_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.data) !== null && _this$props$data !== void 0 ? _this$props$data : '',
      attachments: (_this$props$attachmen = (_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.attachments) !== null && _this$props$attachmen !== void 0 ? _this$props$attachmen : [],
      errors: [],
      isLoading: false,
      EditorComponent: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSubmit", /*#__PURE__*/function () {
      var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(content, attachments, hasFileInProgress) {
        var _request;

        var _this$props3, request, props, submitRequest, _props$replyId, _response, errors, newErrors, replyId, publicReplyId, contentType, _isSpam, isPending, errorMessage, postAttachments, _response$data$succes, _response$headers$loc2, redirectUrl, _error$response$data, _error$response$data$, _error$response$data2, _error$response$data3, _error$response$data4, _errorMessage;

        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this$props3 = _this.props, request = _this$props3.submitRequest, props = (0, _objectWithoutProperties2.default)(_this$props3, _excluded);
                submitRequest = (_request = request === null || request === void 0 ? void 0 : request(props)) !== null && _request !== void 0 ? _request : determineRequest(props);

                _this.setState({
                  isLoading: true
                });

                _context4.prev = 3;
                _context4.next = 6;
                return submitRequest(content, attachments.map(function (item) {
                  return item;
                }), hasFileInProgress);

              case 6:
                _response = _context4.sent;
                errors = _response.data.errors;

                if (!(errors !== null && errors !== void 0 && errors.length)) {
                  _context4.next = 12;
                  break;
                }

                newErrors = errors.map(function (error) {
                  return {
                    errorMessage: error
                  };
                });

                _this.setState(function (prevState) {
                  return {
                    errors: prevState.errors.concat(newErrors),
                    isLoading: false
                  };
                });

                return _context4.abrupt("return");

              case 12:
                replyId = (_props$replyId = props.replyId) !== null && _props$replyId !== void 0 ? _props$replyId : getReplyIdFromResponse(_response);
                publicReplyId = props.publicReplyId;

                if (!replyId) {
                  _context4.next = 30;
                  break;
                }

                contentType = props.type === 'conversation' ? 'reply' : props.type + '_reply';
                (0, _utils.checkAttachments)(hasFileInProgress);
                _context4.next = 19;
                return (0, _attachmentService.saveAttachmentsToTopic)(String(replyId), contentType, attachments);

              case 19:
                _this.setState({
                  attachments: attachments
                });

                _context4.next = 22;
                return checkIsSpam(replyId, props.type, true);

              case 22:
                _isSpam = _context4.sent;
                // is-pending header is 1 if reply is pending, 0 if not pending
                isPending = Boolean(Number(_response.headers['is-pending']));

                if (!(_isSpam || isPending)) {
                  _context4.next = 28;
                  break;
                }

                errorMessage = (0, _preact.h)(_phrase.default, {
                  m: "Forum",
                  p: "spam_moderation.reviewbymoderator.message"
                });

                _this.setState(function (prevState) {
                  return {
                    errors: prevState.errors.concat({
                      errorMessage: errorMessage
                    }),
                    isLoading: false
                  };
                });

                return _context4.abrupt("return");

              case 28:
                _context4.next = 35;
                break;

              case 30:
                if (!props.isTopicEdit) {
                  _context4.next = 35;
                  break;
                }

                (0, _utils.checkAttachments)(hasFileInProgress);
                _context4.next = 34;
                return (0, _attachmentService.saveAttachmentsToTopic)(String(props.topicId), props.type, attachments);

              case 34:
                _this.setState({
                  attachments: attachments
                });

              case 35:
                if (!publicReplyId) {
                  _context4.next = 42;
                  break;
                }

                _context4.next = 38;
                return (0, _attachmentService.getAttachmentsForReplies)(publicReplyId);

              case 38:
                postAttachments = _context4.sent;
                props.onSuccess(content, postAttachments[publicReplyId], _response);
                _context4.next = 43;
                break;

              case 42:
                props.onSuccess(content, attachments, _response);

              case 43:
                if (!props.redirect) {
                  _context4.next = 47;
                  break;
                }

                (0, _globals.publish)('post_editor_submit', {
                  content: content
                });
                redirectUrl = (_response$data$succes = _response.data.success) !== null && _response$data$succes !== void 0 ? _response$data$succes : ((_response$headers$loc2 = _response.headers.location) !== null && _response$headers$loc2 !== void 0 ? _response$headers$loc2 : '').replace('/v2', '');
                return _context4.abrupt("return", (0, _redirect.delayedRedirect)(redirectUrl));

              case 47:
                _this.setState({
                  errors: []
                });

                window.CKEDITOR.instances.editor1.setData('');
                _context4.next = 55;
                break;

              case 51:
                _context4.prev = 51;
                _context4.t0 = _context4["catch"](3);
                _errorMessage = ((_error$response$data = _context4.t0.response.data) === null || _error$response$data === void 0 ? void 0 : (_error$response$data$ = _error$response$data.errors) === null || _error$response$data$ === void 0 ? void 0 : _error$response$data$.pagetext) || ((_error$response$data2 = _context4.t0.response.data) === null || _error$response$data2 === void 0 ? void 0 : (_error$response$data3 = _error$response$data2.errors) === null || _error$response$data3 === void 0 ? void 0 : _error$response$data3.content) || ((_error$response$data4 = _context4.t0.response.data) === null || _error$response$data4 === void 0 ? void 0 : _error$response$data4.errors) || "Something's gone wrong";

                _this.setState(function (prevState) {
                  return {
                    errors: prevState.errors.concat({
                      errorMessage: _errorMessage
                    })
                  };
                });

              case 55:
                _this.setState({
                  isLoading: false
                });

              case 56:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[3, 51]]);
      }));

      return function (_x7, _x8, _x9) {
        return _ref5.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChange", function (content, attachments) {
      // eslint-disable-next-line react/no-unused-state
      _this.setState({
        content: content,
        attachments: attachments
      }); // Notify parent component of changes


      if (_this.props.onChange) {
        _this.props.onChange(content, attachments);
      }
    });
    return _this;
  }

  (0, _createClass2.default)(PostEditor, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
        var _this2 = this;

        var lazyEditorEnabled, mod;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                lazyEditorEnabled = _common.common.isModuleActive('editorLazyLoading');

                if (!(lazyEditorEnabled && 'IntersectionObserver' in window)) {
                  _context6.next = 6;
                  break;
                }

                this.observer = new IntersectionObserver( /*#__PURE__*/function () {
                  var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(entries) {
                    var _iterator, _step, entry, _this2$observer, mod;

                    return _regenerator.default.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            _iterator = _createForOfIteratorHelper(entries);
                            _context5.prev = 1;

                            _iterator.s();

                          case 3:
                            if ((_step = _iterator.n()).done) {
                              _context5.next = 13;
                              break;
                            }

                            entry = _step.value;

                            if (!(entry.isIntersecting && !_this2.state.EditorComponent)) {
                              _context5.next = 11;
                              break;
                            }

                            _context5.next = 8;
                            return import('@insided/shared/uikit/Editor');

                          case 8:
                            mod = _context5.sent;

                            _this2.setState({
                              EditorComponent: mod.default
                            });

                            (_this2$observer = _this2.observer) === null || _this2$observer === void 0 ? void 0 : _this2$observer.disconnect();

                          case 11:
                            _context5.next = 3;
                            break;

                          case 13:
                            _context5.next = 18;
                            break;

                          case 15:
                            _context5.prev = 15;
                            _context5.t0 = _context5["catch"](1);

                            _iterator.e(_context5.t0);

                          case 18:
                            _context5.prev = 18;

                            _iterator.f();

                            return _context5.finish(18);

                          case 21:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5, null, [[1, 15, 18, 21]]);
                  }));

                  return function (_x10) {
                    return _ref6.apply(this, arguments);
                  };
                }());
                if (this.intersectionRef.current) this.observer.observe(this.intersectionRef.current);
                _context6.next = 10;
                break;

              case 6:
                _context6.next = 8;
                return import('@insided/shared/uikit/Editor');

              case 8:
                mod = _context6.sent;
                this.setState({
                  EditorComponent: mod.default
                });

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$observer;

      (_this$observer = this.observer) === null || _this$observer === void 0 ? void 0 : _this$observer.disconnect();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var props = this.props;
      var Editor = this.state.EditorComponent;
      return (0, _preact.h)("div", {
        ref: this.intersectionRef
      }, (0, _preact.h)(_PageUnloadContext.PageUnloadContext.Consumer, null, function (_ref7) {
        var lock = _ref7.lock;
        return Editor ? (0, _preact.h)(Editor, (0, _extends2.default)({}, props, {
          disableFileAttachments: props.disableFileAttachments,
          isControl: props.isControl,
          parentReplyId: props.parentReplyId,
          autoFocus: !!props.autoFocus,
          errors: _this3.state.errors,
          isLoading: _this3.state.isLoading,
          profile: props.profile,
          onSubmit: /*#__PURE__*/function () {
            var _ref8 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(content, attachments, hasFileInProgress) {
              return _regenerator.default.wrap(function _callee7$(_context7) {
                while (1) {
                  switch (_context7.prev = _context7.next) {
                    case 0:
                      _context7.next = 2;
                      return _this3.handleSubmit(content, attachments, hasFileInProgress);

                    case 2:
                      return _context7.abrupt("return", _context7.sent);

                    case 3:
                    case "end":
                      return _context7.stop();
                  }
                }
              }, _callee7);
            }));

            return function (_x11, _x12, _x13) {
              return _ref8.apply(this, arguments);
            };
          }(),
          sendButtonText: props.sendButtonText,
          callback: props.callback,
          onInstanceReady: props.onInstanceReady,
          attachments: _this3.state.attachments,
          onChange: function onChange(content, attachments) {
            _this3.onChange(content, attachments);

            lock(content, props.data);
          }
        })) : (0, _preact.h)("output", {
          "aria-live": "polite",
          "aria-busy": "true",
          "aria-label": "Loading editor"
        }, (0, _preact.h)(_Skeleton.TextSkeleton, {
          style: {
            height: '30px'
          }
        }), (0, _preact.h)(_Skeleton.RectangleSkeleton, {
          height: "300px"
        }));
      }));
    }
  }]);
  return PostEditor;
}(_preact.Component);

var _default = PostEditor;
exports.default = _default;